// Feedback configuration
export const FEEDBACK_CONFIG = {
  // Formspree form ID
  // Create a new form at https://formspree.io and get the ID
  formspreeFormId: 'xeovqjge',

  // Alternative: EmailJS configuration
  emailjs: {
    serviceId: 'your-service-id',
    templateId: 'your-template-id',
    publicKey: 'your-public-key',
  },

  // Direct email configuration (requires backend support)
  directEmail: {
    recipient: 'your-email@example.com',
    subject: 'CodePlato User Feedback',
  }
};

// Get current configuration
export const getCurrentConfig = () => {
  // Priority: Use Formspree
  if (FEEDBACK_CONFIG.formspreeFormId && FEEDBACK_CONFIG.formspreeFormId !== 'your-form-id') {
    return {
      type: 'formspree',
      endpoint: `https://formspree.io/f/${FEEDBACK_CONFIG.formspreeFormId}`,
    };
  }

  // Alternative: EmailJS
  if (FEEDBACK_CONFIG.emailjs.serviceId && FEEDBACK_CONFIG.emailjs.serviceId !== 'your-service-id') {
    return {
      type: 'emailjs',
      ...FEEDBACK_CONFIG.emailjs,
    };
  }

  // Default: Return development mode configuration
  return {
    type: 'development',
    message: 'Please configure Formspree or EmailJS to enable email sending',
  };
};